export default __webpack_public_path__ + "static/media/louvre_lights_off.6460393e.jpg";